import { gql } from '__generated__'

export const GetCandidateLocationPreferenceOptions = gql(/* GraphQL */ `
    query GetCandidateLocationPreferenceOptions {
        preferenceLocations {
            id
            value
        }
    }
`)

export const GetCandidateIndustryPreferenceOptions = gql(/* GraphQL */ `
    query GetCandidateIndustryPreferenceOptions {
        preferenceIndustries {
            id
            value
        }
    }
`)

export const GetCandidateSectorPreferenceOptions = gql(/* GraphQL */ `
    query GetCandidateSectorPreferenceOptions {
        sectors {
            id
            value
        }
    }
`)

export const GetCandidateRecruitingPreferences = gql(/* GraphQL */ `
    query GetCandidateRecruitingPreferences($id: ID!) {
        candidate(userId: $id) {
            id
            user {
                id
            }
            preferencesNote
            startDate {
                value
            }
            candidateIntakes {
                completionDate
            }
            locationPreferences {
                preferenceLocationId
                order
                preferenceLocation {
                    id
                    value
                }
            }
            sectorPreferences {
                order
                sectorId
                sector {
                    id
                    value
                }
            }
            industryPreferences {
                preferenceIndustry {
                    id
                    value
                }
                preferenceIndustryId
                order
            }
        }
    }
`)

//separate query for noteTemplate
export const GetRecruitmentPreferenceNoteTemplate = gql(/* GraphQL */ `
    query GetRecruitmentPreferenceNoteTemplate($templateType: TemplateType!) {
        noteTemplate(templateType: $templateType) {
            id
        }
    }
`)
